import Swiper from 'swiper';
import { MOBILE } from '../../assets/scripts/constants';
import { FreeMode, Mousewheel, Navigation } from 'swiper/modules';

class Gallery {
	constructor(el) {
		if (el.dataset.gallery === 'ignore') return;

		this.el = el;
		this.mm = window.matchMedia(MOBILE);
		this.swiper = null;

		this.toggleSwiper(this.mm.matches);

		this.mm.addEventListener('change', (e) => {
			this.toggleSwiper(e.matches);
		});
	}

	initSwiper() {
		const container = this.el;
		if (!container) return;

		this.buttonPrev = container.querySelector('.gallery__nav-button._prev');
		this.buttonNext = container.querySelector('.gallery__nav-button._next');

		const mm = window.matchMedia(MOBILE);

		const onMMChange = () => {
			if (mm.matches) {
				if (this.swiper) {
					this.swiper.destroy(true, true);
					this.swiper = null;
				}
			} else {
				this.swiper = new Swiper(container.querySelector('.swiper'), {
					slidesPerView: 2,
					spaceBetween: 1,
					speed: 600,
					observer: true,
					observeParents: true,
					modules: [FreeMode, Mousewheel, Navigation],
					watchSlidesProgress: true,
					freeMode: false,
					mousewheel: {
						forceToAxis: true,
						releaseOnEdges: true,
						sensitivity: 1,
					},
					navigation: {
						nextEl: this.buttonNext,
						prevEl: this.buttonPrev,
					},
					breakpoints: {
						768: {
							slidesPerView: 'auto',
							freeMode: {
								enabled: true,
								sticky: false,
								momentumRatio: 0.4,
								momentumBounce: false,
								momentumVelocityRatio: 0.4,
							},
						},
					},
				});
			}
		};

		onMMChange();
		mm.addEventListener('change', onMMChange);
	}

	destroySwiper() {
		if (this.swiper) {
			this.swiper.destroy(true, true);
			this.swiper = null;
		}
	}

	toggleSwiper(isMobile) {
		const isMobileDisabled = this.el.dataset.galleryMobile === 'false';

		if ((isMobile && !isMobileDisabled) || !isMobile) {
			if (!this.swiper) this.initSwiper();
		} else {
			this.destroySwiper();
		}
	}
}

document.querySelectorAll('[data-gallery]').forEach((el) => new Gallery(el));
export default Gallery;
